export default __webpack_public_path__ + "_24-0622_DBG_SeqSense_Omnition_RNA_Graphic_FINAL_expanded.svg";